(function ($, window, document) {

function onDOMContentLoaded() {
  $('.js-faq-category-questions').each(function () {
    var options = {
      toggleButtonTextShow: $(this).find('.js-button-show-text').html(),
      toggleButtonTextHide: $(this).find('.js-button-hide-text').html()
    };

    $(this).collectionItemToggler(options);
  });
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
